export default __webpack_public_path__ + "assets/images/731ef85b24a1dc2440968c0934803f58.png";